import withRoute from "./classes/withRoute";
import Base from '@gqlapp/router/classes/Route';

export default function Route({ component: C, ...props}){
	return Base({...props, component: withRoute(C)});
}